// Mirrors the backend search-query validation so bad input is rejected client-side.
// Allowed: letters, digits, space, underscore, dash, dot, apostrophe, parentheses, slash.
// Rejected: semicolons and standalone "or"/"union" tokens (basic SQL-injection guard).
export function isValidSearchQuery(value) {
    const q = String(value ?? "").trim();
    if (!q) return true; // empty clears the filter — treated as valid
    if (/[;]/.test(q) || /\bor\b|\bunion\b/i.test(q)) return false;
    if (!/^[a-z0-9 _.\-'()/]+$/i.test(q)) return false;
    return true;
}
